export { wrapRootElement } from './src/components/layout/wrapRootElement';
export { wrapPageElement } from './src/components/layout/wrapPageElement';

export const onServiceWorkerUpdateReady = () => {
    window.location.reload();
};